import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import LocalActivityOutlinedIcon from "@mui/icons-material/LocalActivityOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { PackageOfferText } from "./PackageOfferHint";

/**
 * The pack nudge as a strip across a slot list, directly under the day picker.
 *
 * A slot search has no card to hang the hint on — the tiles hide their price
 * whenever the day agrees on one, and the offer is the same at every time — so
 * it is stated once, where the client is already looking to choose a day.
 *
 * A solid block of the club's colour with the offer as one bold line. It used
 * to be a pale tint of that colour on a page washed in the same colour, with
 * the whole offer in small print — easy to scroll straight past. The sentence
 * already says "Purchase a pack", so the arrow is the only call to action.
 */
function PackageOfferBanner({ offer, currency, onClick, sx }) {
  if (!offer) return null;

  return (
    <ButtonBase
      onClick={() => onClick()}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, md: 1.25 },
        px: 1.5,
        py: { xs: 1, md: 1.25 },
        borderRadius: 2.5,
        bgcolor: "primary.main",
        color: "primary.contrastText",
        textAlign: "left",
        boxShadow: (theme) => `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
        "&:hover": { bgcolor: "primary.dark" },
        "&:hover .offer-arrow": { transform: "translateX(0.125rem)" },
        ...sx
      }}
    >
      <LocalActivityOutlinedIcon sx={{ flexShrink: 0, fontSize: { xs: "1.125rem", md: "1.375rem" } }} />
      <Typography component="span" sx={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: { xs: "0.78rem", md: "0.875rem" }, lineHeight: 1.35 }}>
        <PackageOfferText offer={offer} currency={currency} />
      </Typography>
      <ChevronRightIcon
        className="offer-arrow"
        sx={{ flexShrink: 0, fontSize: { xs: "1.125rem", md: "1.375rem" }, transition: "transform 0.15s ease" }}
      />
    </ButtonBase>
  );
}

export default PackageOfferBanner;
